import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
import { truncateLines } from '../../../../../../utils/common';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Container')(
  css({
    backgroundColor: 'white',
    border: '1px solid',
    borderColor: 'grey.2',
    padding: '24px',
    borderRadius: '3px',
    marginTop: ['20px', '20px', 0],
  }),
);

themeStyles.addBaseStyles('Title')(
  css({
    marginBottom: '4px',
    color: 'black',
    fontSize: ['16px', '16px', '18px'],
    lineHeight: ['20px', '20px', '22px'],
  }),
);

themeStyles.addBaseStyles('Text')(
  css({
    color: 'black',
    fontSize: '14px',
    lineHeight: ['22px', '22px', '24px'],
  }),
);

themeStyles.addBaseStyles('IconLabel')(
  css({
    color: 'black',
    fontSize: '14px',
    lineHeight: '22px',
    margin: 'auto 0',
    fontFamily: 'bold',
    ...truncateLines(1),
  }),
);

themeStyles.addBaseStyles('IconsWrapper')(
  css({
    marginTop: '4px',
    paddingLeft: '10px',
  }),
);

themeStyles.addBaseStyles('IconWrapper')(
  css({
    display: 'flex',
    gap: '3px',
    margin: 'auto 0',
  }),
);

themeStyles.addBaseStyles('CenteredItem')(({ height = '18px' }) =>
  css({
    height,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '26px',
    flexShrink: 0,
    margin: 'auto 0',
  }),
);

export default themeStyles;
